const stats = [
  { value: '5000万+', label: '日活用户', icon: 'ri-user-line' },
  { value: '100万+', label: '优质创作者', icon: 'ri-star-line' },
  { value: '2亿+', label: '视频总量', icon: 'ri-film-line' },
  { value: '99.9%', label: '服务可用率', icon: 'ri-cloud-line' },
];

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20 bg-gradient-to-r from-primary-500 to-primary-600">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-white/15 flex items-center justify-center">
                <i className={`${stat.icon} text-white text-xl`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-bold text-white mb-1">{stat.value}</div>
              <div className="text-sm text-white/70">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}